import React, { FunctionComponent } from 'react';

import {ReactComponent as RatingStarFull} from '../../../../assets/icons/icon_star_active.svg';
import {ReactComponent as RatingStarEmpty} from '../../../../assets/icons/icon_star_inactive.svg';

interface Props {
    active: boolean;
    onClick: (active: boolean) => void;

    className?: string;
}

const FavoriteIcon: FunctionComponent<Props> = ({ active, onClick, className }) => {

    const Icon = active ? RatingStarFull : RatingStarEmpty;

    return (
        <Icon className={className} onClick={() => onClick(!active)} />
    );
};

export default FavoriteIcon;
